export function stringToBooleans(str: string): boolean {
    if (str !== null) {
        // 忽略大小写并比较字符串
        if (str.toLowerCase() === 'true') {
            return true
        } else if (str.toLowerCase() === 'false') {
            return false
        } else {
            // 如果字符串既不是 "true" 也不是 "false"，可以根据需要返回 true 或 false
            // 这里我们选择返回 false，表示未知的字符串被视为假值
            return false
        }
    } else {
        return true
    }
}
